import isNil from 'lodash/isNil';
import merge from 'lodash/merge';
import pickBy from 'lodash/pickBy';

import { RANGE_PICKER } from '@nocowanie/core/consts';

import { SearchFormDataType } from './search-engine-container.props';

import { SearchEngineModel } from '../../../models';
import { defaultGuestsPickerConfig } from '../../molecules/guests-picker/guests-picker.config';

export const defaultSearchFormData = (): SearchEngineModel => ({
    location: '',
    dates: {
        checkInDate: null,
        checkOutDate: null,
    },
    guests: {
        adultsCount: defaultGuestsPickerConfig?.adultsConfig.default as number,
        childrenCount: defaultGuestsPickerConfig?.childrenConfig.default as number,
        childrenAges: [],
    },
    instantReservation: undefined,
    flexDates: RANGE_PICKER.FLEX_DATES.DEFAULT,
});

export const assignDefaultValuesIfNeeded = (source: SearchFormDataType): SearchEngineModel => {
    return merge(
        {},
        defaultSearchFormData(),
        pickBy(source, value => !isNil(value)),
    );
};
